import { render, staticRenderFns } from "./FunctionCfg.vue?vue&type=template&id=98e98bce&scoped=true&"
import script from "./FunctionCfg.vue?vue&type=script&lang=js&"
export * from "./FunctionCfg.vue?vue&type=script&lang=js&"
import style0 from "./FunctionCfg.vue?vue&type=style&index=0&id=98e98bce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e98bce",
  null
  
)

export default component.exports